import { Link, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import React from "react";

const SideNav = () => {
  const { id } = useParams();

  const logCheck = localStorage.getItem("data");
  const sidebarMenu = JSON.parse(localStorage.getItem("sidebarMenu") || "[]");
  const SECTION_HEADERS = {
    student: "Data",
    video: "Contents",
    qrdata: "Qr Data",
    roadsafetyclub: "Club",
  };
  let lastSection = null;
  let decoded_data = "";
  if (logCheck != null) {
    decoded_data = jwt_decode(logCheck);
  }

  return (
    <div>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <Link
          to="/"
          className="brand-link"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src="logo.png"
            alt="AdminLTE Logo"
            className="elevation-1"
            style={{ padding: 5, width: "100px", borderRadius: "10%" }}
          />
        </Link>
        <div
          className="sidebar"
          style={{
            height: `calc(100vh - (10.5rem + 1px))`,
          }}
        >
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <img
                src="dist/img/user2-160x160.jpg"
                className="img-circle elevation-2"
                alt="User Image"
              />
            </div>
            <div className="info">
              <a href="#" className="d-block">
                {decoded_data.user.name}
              </a>
            </div>
          </div>

          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {sidebarMenu.map((item, index) => {
                // List of admin-only codes
                const adminOnlyCodes = [
                  "adduser",
                  "addadmin",
                  "banner",
                  "notification",
                  "question",
                  "module",
                  "worksheet",
                  "readingmaterial",
                  "roadsafetyclub",
                  "qrdata",
                  "video",
                  "supportticket",
                ];

                // Check if this menu item should be shown
                const isAdminOnly = adminOnlyCodes.includes(item.code);
                if (isAdminOnly && decoded_data.user.role !== "admin") {
                  return null; // Skip this item if not admin
                }

                // Handle section headers
                const currentSection = SECTION_HEADERS[item.code];
                const shouldRenderHeader =
                  currentSection && currentSection !== lastSection;
                const sectionHeader = shouldRenderHeader ? (
                  <li className="nav-header" key={`header-${currentSection}`}>
                    {currentSection}
                  </li>
                ) : null;
                if (shouldRenderHeader) lastSection = currentSection;

                // Render the menu item
                return (
                  <React.Fragment key={index}>
                    {sectionHeader}
                    <li className="nav-item">
                      <Link to={item.url} className="nav-link">
                        <i className={`nav-icon ${item.icon}`} />
                        <p>{item.name}</p>
                      </Link>
                    </li>
                  </React.Fragment>
                );
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default SideNav;
